import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Button, HTML, Dropdown } from '../index';

import styles from './tabs.module.scss';
import { applyClasses, applyProps } from '../shared/js';
import Tab from './Tab';

const Tabs = ({ id, defaultTab, mobileLabel, ...props }) => {
  const [openTab, setOpenTab] = useState(defaultTab);
  const options = props.children.map((child, index) => ({
    value: `${index}`,
    label: child.props.title,
    selectedLabel: child.props.title,
  }));
  return (
    <>
      <HTML
        className={cn(
          styles.tabs,
          // eslint-disable-next-line react/prop-types
          props.className,
          applyClasses(props, styles)
        )}
        hideOnTablet
        {...applyProps(props)}
      >
        <div className={styles.buttons}>
          {props.children?.map((child, index) => {
            if (child.type !== Tab)
              throw new Error('Child of Tabs must be of type Tab');
            return (
              <Button
                id={child.props.id || `${id}_${index + 1}`}
                key={index}
                onClick={() => setOpenTab(`${index}`)}
                className={cn(
                  styles.tab,
                  child.props.className,
                  { [styles.open]: openTab === `${index}` },
                  applyClasses(child.props, styles)
                )}
              >
                {child.props.title}
              </Button>
            );
          })}
        </div>
        {props.children?.map((child, index) => {
          if (child.type !== Tab)
            throw new Error('Child of Tabs must be of type Tab');
          return React.cloneElement(
            child,
            {
              key: index,
              isOpen: openTab === `${index}`,
            },
            child.props.children
          );
        })}
      </HTML>
      <HTML tabletOnly>
        <Dropdown
          options={options}
          label={mobileLabel}
          primary
          defaultValue={openTab}
          value={openTab}
          onChange={(v) => setOpenTab(v)}
          mbMd
        />
        {props.children?.map((child, index) => {
          if (child.type !== Tab)
            throw new Error('Child of Tabs must be of type Tab');
          return (
            `${index}` === openTab && (
              <div key={index}>{child.props.children}</div>
            )
          );
        })}
      </HTML>
    </>
  );
};

Tabs.propTypes = {
  /** The ID of the tabs element. Useful to select the tabs during testing. Can be used as a default value for each tab's ID if one isn't provided to them */
  id: PropTypes.string,
  /** The index of the tab that should be open by default */
  defaultTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Label to show in mobile view of tabs */
  mobileLabel: PropTypes.any,
  /** The child Tab components to display in the section */
  children: PropTypes.any,
};

Tabs.defaultProps = {
  defaultTab: '0',
  children: undefined,
  mobileLabel: undefined,
};

Tabs.Tab = Tab;
export default Tabs;
